export const selector = ({ checkout, places, appConfiguration }) => ({
  pending: checkout.pending,
  citizens: places.citizen,
  countries: places.countries,
  localize: appConfiguration.localize,
  phoneTypes: appConfiguration.sharedConfig.phoneTypes,
  userData: checkout.requestData
});
